import React from 'react';
import { Grid, Table, Divider } from 'semantic-ui-react';
import withDataFetch from '../../api/withDataFetch';
import withFullScreenLoader from '../UtilityComponents/withFullScreenLoading/index';
import { renderDataAsHtml, renderDataAsPlainText } from '../../api/renderPrismicData';
import TableItems from './TableItems';

const Prices = ({
  data: {
    title,
    paragraph,
    paragraph1,
    table,
    table1,
  },
  docId,
}) => {
  return (
    <Grid className="Prices" doc-wio-id={docId}>
      <Grid.Row centered>
        <h2 className="Page__Title">
          {renderDataAsPlainText(title)}
        </h2>
      </Grid.Row>
      <Divider />
      <Grid.Row>
        {renderDataAsHtml(paragraph)}
        <Table stackable celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={13}>Beschrijving</Table.HeaderCell>
              <Table.HeaderCell width={3}>Prijs</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <TableItems items={table} />
        </Table>
        {renderDataAsHtml(paragraph1)}
        <Table stackable celled>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={13}>Beschrijving</Table.HeaderCell>
                <Table.HeaderCell width={3}>Prijs</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <TableItems items={table1} />
          </Table>
        </Table>
      </Grid.Row>
    </Grid>
  );
};

export default withDataFetch(withFullScreenLoader(Prices), 'tarieven');



// WEBPACK FOOTER //
// ./src/components/Prices/index.js